import PdfViewer from "../../../../atoms/pdf-viewer/pdf";
import NoResultFoundFilters from "../../../../atoms/noResultsFilters";

type Props = {
  pdfBlobUrl: string;
};

function ZohoExpertStatementPdfViewer({ pdfBlobUrl }: Props) {

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <>
      {
        pdfBlobUrl ? 
        <PdfViewer pdfUrl={pdfBlobUrl} /> :
        <NoResultFoundFilters text={"No Data Found"} />
      }
      </>
    </div>
  );
}

export default ZohoExpertStatementPdfViewer;
